import { render } from "./contribution-schedule.vue?vue&type=template&id=ddb5a4fa&scoped=true"
import script from "./contribution-schedule.vue?vue&type=script&lang=js"
export * from "./contribution-schedule.vue?vue&type=script&lang=js"

import "./contribution-schedule.vue?vue&type=style&index=0&id=ddb5a4fa&scoped=true&lang=css"
import "./contribution-schedule.vue?vue&type=style&index=1&id=ddb5a4fa&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb5a4fa"]])

export default __exports__